import React from 'react';
import { ArrowRight, Clock, Monitor, Infinity as InfinityIcon } from 'lucide-react';
import { img, WHATSAPP } from '../mock';

const ProjectPlatform = () => {
  return (
    <section className="py-10">
      {/* Choose Unreal Viz intro */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div className="reveal">
            <span className="label-mono">// SCEGLIERE UNREAL VIZ</span>
            <h2 className="mt-4 font-display font-semibold text-white text-3xl md:text-4xl leading-tight">
              La Masterclass italiana su Unreal Engine 5 per l&rsquo;Archviz. <span className="gold-text">Ora finalmente disponibile</span>
            </h2>
            <p className="mt-6 text-neutral-400 leading-relaxed">
              Il punto di riferimento per imparare Unreal Engine in modo professionale e concreto, senza perdite di
              tempo inutili. Corso completamente pre-registrato e disponibile su una piattaforma dedicata, per
              accedervi quando vuoi, da qualsiasi dispositivo.
            </p>
            <p className="mt-4 text-neutral-400 leading-relaxed">
              Parti da zero o hai già esperienza: non importa. Il corso ti forma dalle fondamenta fino alla
              produzione di contenuti fotorealistici di livello professionale. Il punto di partenza non conta. Conta
              dove vuoi arrivare.
            </p>
            <a href={WHATSAPP} target="_blank" rel="noreferrer"
              className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/25 text-white font-medium hover:border-[var(--uv-gold)] hover:text-[var(--uv-gold)] transition-colors">
              Accedi al corso <ArrowRight size={18} />
            </a>
          </div>
          <div className="rounded-2xl overflow-hidden border border-white/10 aspect-[4/3] reveal">
            <img src={img.platform} alt="piattaforma" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>

      {/* Project - Farnsworth House */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
        <div className="relative rounded-3xl overflow-hidden border border-white/10 reveal">
          <div className="absolute inset-0">
            <img src={img.project} alt="Farnsworth House" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0c0c0e] via-[#0c0c0e]/70 to-[#0c0c0e]/30" />
          </div>
          <div className="relative p-8 md:p-14 lg:p-16">
            <span className="label-mono">// IL PROGETTO DEL CORSO</span>
            <h2 className="mt-4 font-display font-semibold text-white text-3xl md:text-5xl max-w-3xl leading-tight">
              Realizziamo l&rsquo;iconica <span className="gold-text">Farnsworth House</span>, in Unreal Engine 5
            </h2>
            <p className="mt-3 text-neutral-400 font-mono-uv text-xs tracking-wider">Mies van der Rohe · 1951 · Piano, Illinois</p>
            <div className="mt-8 max-w-2xl space-y-4 text-neutral-300 leading-relaxed">
              <p>
                Un progetto iconico. Un metodo replicabile. La Farnsworth House è il progetto perfetto per imparare
                Unreal Engine: geometria pulita, luce naturale complessa, materiali raffinati, rapporto interno-esterno
                sofisticato.
              </p>
              <p>
                Non lavoriamo su scene semplificate o asset fittizi. Partiamo da un modello reale, affrontiamo i
                problemi reali di un progetto cliente, e arriviamo a un risultato che puoi mettere direttamente nel tuo
                portfolio.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Platform */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
        <div className="text-center max-w-3xl mx-auto reveal">
          <span className="label-mono">// LA PIATTAFORMA</span>
          <h2 className="mt-4 font-display font-semibold text-white text-3xl md:text-5xl leading-tight">
            Una piattaforma. Oltre 70 lezioni. <span className="gold-text">Zero scadenze.</span>
          </h2>
          <p className="mt-5 text-neutral-400">
            Tutto pre-registrato, disponibile 24 ore su 24, da qualsiasi dispositivo. Segui al tuo ritmo — non al nostro.
          </p>
        </div>
        <div className="mt-10 grid sm:grid-cols-3 gap-5 max-w-4xl mx-auto">
          {[
            { icon: Monitor, t: 'Qualsiasi dispositivo', d: 'Desktop, tablet o smartphone' },
            { icon: Clock, t: 'Disponibile 24/7', d: 'Nessun orario, nessun vincolo' },
            { icon: InfinityIcon, t: 'Accesso a vita', d: 'Aggiornamenti futuri inclusi' },
          ].map((f, i) => (
            <div key={i} style={{ transitionDelay: `${i * 0.12}s` }} className="card-shine rounded-2xl border border-white/10 bg-[var(--uv-surface)] p-7 text-center reveal-scale">
              <f.icon size={28} className="text-[var(--uv-gold)] mx-auto" />
              <div className="mt-4 font-display font-medium text-white text-lg">{f.t}</div>
              <div className="mt-1 text-sm text-neutral-400">{f.d}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectPlatform;
